export default __webpack_public_path__ + "static/media/3168.1b9fdee8.svg";